import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import { useMedia } from "react-use";

import { IEditableSectionRenderProps } from "@/components/EditableSection";
import { Group } from "@/components/Group";
import { Header } from "@/components/Header";
import { Text } from "@/components/Text";
import { MEDIA_SIZE_SM } from "@/core/media";
import { Flex } from "@/eworkitComponents";
import { useCodelistTranslation } from "@/hooks/Codelist";
import { useFormats } from "@/hooks/Formats";
import { IConsultantProfileSectionProps } from "@/views/components/ConsultantProfile/Sections/types";

import { WorkPreferencesSection } from "../WorkPreferencesSection";
import { AvailabilitySectionEdit } from "./AvailabilitySectionEdit";

interface IAvailabilitySectionProps extends IConsultantProfileSectionProps, IEditableSectionRenderProps {}

export const AvailabilitySection: FC<IAvailabilitySectionProps> = ({ editableProps, record, onUpdate }) => {
  const { t } = useTranslation("session");
  const tCodelist = useCodelistTranslation();
  const { formatDate } = useFormats();

  const isSmallScreen = useMedia(MEDIA_SIZE_SM);

  return (
    <Flex direction="column" innerMargin="md">
      <Header size="sm" color="black" weight="bold">
        {t("CONSULTANT_PROFILES.DETAIL.AVAILABILITY.SECTION_HEADER")}
      </Header>

      {editableProps.editMode ? (
        <AvailabilitySectionEdit
          source={record}
          initialValues={record}
          editableProps={editableProps}
          onUpdate={onUpdate}
          onCancel={editableProps.handleCancelClick}
        />
      ) : (
        <Flex direction={isSmallScreen ? "column" : "row"} innerMargin="md">
          <Flex width={isSmallScreen ? 12 : 6}>
            <Group label={t("CONSULTANT_PROFILES.DETAIL.AVAILABILITY.NOTICE_PERIOD_LABEL")} direction="column">
              <Text size="md">
                {record.availabilityDate
                  ? formatDate(record.availabilityDate)
                  : tCodelist("availability", record.availability)}
              </Text>
            </Group>
          </Flex>

          <Flex width={isSmallScreen ? 12 : 6}>
            <WorkPreferencesSection record={record} direction="column" />
          </Flex>
        </Flex>
      )}
    </Flex>
  );
};
